import {NgOptimizedImage} from '@angular/common';
import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {HOME} from '../../constants';

@Component({
  selector: 'cov-logo',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  protected readonly HOME = HOME;
}
